import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Observable, throwError, BehaviorSubject } from 'rxjs';
//import { catchError, retry, map, tap } from 'rxjs/operators';
import { APIResponse, Employee, OrderStop, PostCreateTMWOrder, QuoteOrderLine, TMWLabelFile } from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class TMWService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    }

    //public getCarrierByCode(carrierCode: string) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/TMW/GetCarrierByCode/?carrierCode=' + carrierCode);
    //}

    //public getIsLoadTMWPriority(quoteOrderLineID: number, carrierID: number) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/TMW/GetIsTMWPriorityByQuoteOrderLineIDCarrierID/?quoteOrderLineID=' + quoteOrderLineID + "&carrierID=" + carrierID);
    //}

    //public getCreditTerms() {
    //    return this.http.get<TMWLabelFile[]>(this.baseUrl + 'api/TMW/GetCreditTerms');
    //}

    //public getRevTypesByNumber(revNumber: number) {
    //    return this.http.get<TMWLabelFile[]>(this.baseUrl + 'api/TMW/GetRevTypesByNumber/?revNumber=' + revNumber);
    //}

    //public createOrderInTmw(quoteOrderLine: QuoteOrderLine, creditTerms: TMWLabelFile, revTypeOne: TMWLabelFile, revTypeTwo: TMWLabelFile,
    //revTypeThree: TMWLabelFile, revTypeFour: TMWLabelFile, carrierRep: Employee) {
    //    var body = {
    //        quoteOrderLine: quoteOrderLine,
    //        creditTerms: creditTerms,
    //        revTypeOne: revTypeOne,
    //        revTypeTwo: revTypeTwo,
    //        revTypeThree: revTypeThree,
    //        revTypeFour: revTypeFour,
    //        carrierRep: carrierRep
    //    } as PostCreateTMWOrder;

    //    return this.http.post<QuoteOrderLine>(this.baseUrl + 'api/TMW/CreateOrderInTMW/', body, httpOptions);
    //}

    //public updateTMW(stopList: OrderStop[]) {
    //    return this.http.post<APIResponse>(this.baseUrl + 'api/TMW/UpdateTMW', stopList, httpOptions);
    //}

    //public updateTMWByLineIDLastUpdate(quoteOrderLineID: number) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/TMW/UpdateTMWByLineIDLastUpdate/?quoteOrderLineID=' + quoteOrderLineID);
    //}

    public exportTMWOrder(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/TMW/ExportTMWOrder/?quoteOrderLineID=' + quoteOrderLineID);
    }

    //public saveTMWAdvancedCarrierSelection(quoteOrderLineList: QuoteOrderLine[]) {
    //    return this.http.post<APIResponse>(this.baseUrl + 'api/TMW/SaveTMWAdvancedCarrierSelection/', quoteOrderLineList, httpOptions);
    //}

    //public updateTMWMove(quoteOrderLineList: QuoteOrderLine[]) {
    //    return this.http.post<APIResponse>(this.baseUrl + 'api/TMW/UpdateTMWMove/', quoteOrderLineList);
    //}
}
